import { PaymentTreatment } from '../../../types';
import { RepeatingMethodState } from '../../../components/repeating/types';

/**
 * Get repeating assumption content for preview route
 */
export const getRepeatingMethodData = (argObj: {
  predictionName: string;
  vatPercentage: string;
  repeatingMethodData: RepeatingMethodState;
  accountIndex: string;
  paymentTreatment: PaymentTreatment;
}) => {
  const { predictionName, vatPercentage, repeatingMethodData, accountIndex, paymentTreatment } = argObj;
  const data = {
    ...repeatingMethodData,
    name: predictionName,
    vat_percentage: paymentTreatment === PaymentTreatment.NON_CASH_TRANSFER ? '0' : vatPercentage || null,
    account_id: accountIndex,
    excluded_from_report: false
  };

  return data;
};
